import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Paths } from '../constants/paths';
import { useProductTypeSearchParams } from '../hooks/useProductTypeSearchParams';
import { getDocumentReferrer } from '../utils/getDocumentReferrer';
import { jsx as _jsx } from "react/jsx-runtime";
const RouteReferrerContext = /*#__PURE__*/createContext(undefined);
export function RouteReferrerProvider({
  children,
  referrer: referrerValue
}) {
  const [referrer, setReferrer] = useState(() => {
    if (referrerValue === 'breeze' || /app\.hubspot(qa)?\.com\/breeze-studio\/\d+/i.test(getDocumentReferrer())) {
      return {
        linkText: I18n.text('marketplaceStorefront.referrerLinkText.breeze'),
        path: Paths.AGENTS,
        productType: 'AGENT',
        referrer: 'breeze',
        referrerUrl: `${getFullUrl('app')}/breeze-studio/${PortalIdParser.get()}`
      };
    }
    return undefined;
  });
  const clearReferrer = useCallback(() => setReferrer(undefined), [setReferrer]);
  const referrerRouteMatch = useRouteMatch({
    path: referrer === null || referrer === void 0 ? void 0 : referrer.path
  });
  const productTypes = useProductTypeSearchParams();
  const {
    path: currentPath
  } = useRouteMatch();
  useEffect(() => {
    if (!(referrer !== null && referrer !== void 0 && referrer.productType)) return;
    if (referrerRouteMatch) return;
    switch (currentPath) {
      case Paths.LISTING_DETAILS:
        break;
      case Paths.SEARCH_RESULTS:
        {
          if (!productTypes.length || !productTypes.every(t => t === referrer.productType)) {
            clearReferrer();
          }
          break;
        }
      default:
        clearReferrer();
        break;
    }
  }, [currentPath, productTypes, referrerRouteMatch, referrer, clearReferrer]);
  return /*#__PURE__*/_jsx(RouteReferrerContext.Provider, {
    value: referrer && referrerRouteMatch ? referrer : undefined,
    children: children
  });
}
export function useRouteReferrer() {
  return useContext(RouteReferrerContext);
}